document.addEventListener('DOMContentLoaded', function () {
    startApp();
});


function startApp() {
    fixedNav();
    createGallery();
    scrollNav();
};

function fixedNav(){
    const taskbar = document.querySelector('.header');
    const aboutFestival = document.querySelector('.about-festival');
    const body = document.querySelector('body');

    window.addEventListener('scroll', function(){

        if(aboutFestival.getBoundingClientRect().bottom < 10){
            taskbar.classList.add('fixed');
            body.classList.add('body-scroll')
        } else{
            taskbar.classList.remove('fixed');
            body.classList.remove('body-scroll')
        }
    });
};

function scrollNav(){
    const links = document.querySelectorAll('.nav-main a');
    links.forEach(links =>{
        links.addEventListener('click', function(e){
            e.preventDefault();

            const secctionScroll = e.target.attributes.href.value;
            const secction = document.querySelector(secctionScroll);
            secction.scrollIntoView({behavior: "smooth"});
        });
    });
};
//Crear galeria
function createGallery() {
    const gallery = document.querySelector('.gallery-images');

    for (let i = 1; i <= 12; i++) {
        const image = document.createElement('picture');
        image.innerHTML = `
        <source srcset="build/img/thumb/${i}.avif" type="image/avif">
        <source srcset="build/img/thumb/${i}.webp" type="image/webp">
        <img loading="lazy" width="200" height="300" src="build/img/thumb/${i}.jpg"
            alt="imagen ${i} galeria">
        `;

        image.onclick = function () {
            showImage(i);
        }
        gallery.appendChild(image);
    }
};

function showImage(id) {
    //Crear imagen grande
    const image = document.createElement('picture');
    image.innerHTML = `
    <source srcset="build/img/grande/${id}.avif" type="image/avif">
    <source srcset="build/img/grande/${id}.webp" type="image/webp">
    <img loading="lazy" width="200" height="300" src="build/img/grande/${id}.jpg"
        alt="imagen grande${id} galeria">
    `;
    //Crear overlay con imagen
    const overlay = document.createElement('DIV');
    overlay.appendChild(image);
    overlay.classList.add('imgOverlay');

    //Añadir a html
    const body = document.querySelector('body');
    body.appendChild(overlay);
    body.classList.add('body-fixed');

    //cerrar modal
    const closeModal = document.createElement('P');
    closeModal.textContent = 'X';
    closeModal.classList.add('btn-close');
    overlay.appendChild(closeModal);

    overlay.onclick = function () {
        FunctionCloseModal();
    };

    closeModal.onclick = function () {
        FunctionCloseModal();
    };

    //Borrar elemntos y clases dependientes de Modal
    function FunctionCloseModal() {
        body.classList.remove('body-fixed');
        overlay.remove();
    };

};
